import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
// import 'vant/lib/index.css'
import '@/styles/index.css'
import FastClick from 'fastclick'
import 'lib-flexible/flexible.js'
import globalMixin from './mixins/global'

Vue.config.productionTip = false
    // http请求挂载到vue原型上
Vue.use(Vant)
FastClick.attach(document.body)
    // 全局混入
Vue.mixin(globalMixin)

new Vue({
        router,
        store,
        render: h => h(App),
        created() {
            // 加载用户登录的数据
            this.$store.dispatch('admin/account/load');
        }
    }).$mount('#app')
    // 路由跳转新页面时，滚动条回到顶部
router.beforeEach((to, from, next) => {
    // chrome

    document.body.scrollTop = 0
        // firefox

    document.documentElement.scrollTop = 0
        // safari

    window.pageYOffset = 0
    next()
})